var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStratgyBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 221,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M765.186 0.105022C765.186 121.281 666.915 219.514 545.693 219.514C424.471 219.514 326.2 121.281 326.2 0.104983",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M773.911 0.10604C773.911 111.588 675.64 202.065 554.418 202.065C433.196 202.065 334.926 111.588 334.926 0.106002",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M782.64 0.107805C782.64 101.895 684.369 184.618 563.147 184.618C441.925 184.618 343.654 101.895 343.654 0.107767",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M791.69 0.105158C791.69 92.1986 693.42 166.843 572.198 166.843C450.976 166.843 352.705 92.1986 352.705 0.10512",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M800.42 0.10255C800.42 82.5019 702.149 149.391 580.927 149.391C459.705 149.391 361.435 82.5019 361.435 0.102512",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M809.146 0.103046C809.146 72.8084 710.875 131.942 589.653 131.942C468.431 131.942 370.16 72.8083 370.16 0.103008",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M817.875 0.105442C817.875 63.1167 719.604 114.172 598.382 114.172C477.16 114.172 378.567 63.1167 378.567 0.105404",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M826.605 0.106461C826.605 53.4237 728.335 96.7237 607.113 96.7237C485.891 96.7237 387.62 53.4237 387.62 0.106423",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M835.654 0.105887C835.654 43.7291 737.384 79.2739 616.162 79.2739C494.94 79.2739 396.669 43.7291 396.669 0.105849",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M844.382 0.10328C844.382 34.0324 746.111 61.4989 624.889 61.4989C503.667 61.4989 405.397 34.0324 405.397 0.103241",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M853.109 0.102465C853.109 24.3376 754.839 44.0488 633.617 44.0488C512.395 44.0488 414.124 24.3375 414.124 0.102427",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M861.838 0.105322C861.838 14.6464 763.567 26.6024 642.345 26.6024C521.123 26.6024 422.853 14.6464 422.853 0.105283",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M545.692 0.103152C545.692 121.279 643.962 219.512 765.184 219.512C886.406 219.512 985 121.279 985 0.103191",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M536.964 0.103072C536.964 111.585 635.235 202.062 756.457 202.062C877.679 202.062 975.949 111.585 975.949 0.103111",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M527.911 0.103983C527.911 101.891 626.182 184.614 747.404 184.614C868.626 184.614 967.22 101.891 967.22 0.104021",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M519.185 0.102678C519.185 92.1961 617.455 166.84 738.677 166.84C859.899 166.84 958.493 92.1962 958.493 0.102717",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M510.456 0.103855C510.456 82.5032 608.727 149.392 729.949 149.392C851.171 149.392 949.765 82.5033 949.765 0.103893",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.729 0.10252C501.729 72.8079 599.999 131.941 721.221 131.942C842.443 131.942 941.037 72.8079 941.037 0.102558",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M493 0.103695C493 63.115 591.271 114.17 712.493 114.17C833.715 114.17 931.985 63.115 931.985 0.103733",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M483.949 0.103249C483.949 53.4205 582.22 96.7206 703.442 96.7206C824.664 96.7206 923.258 53.4205 923.258 0.103287",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M475.222 0.103163C475.222 43.7264 573.492 79.2712 694.714 79.2712C815.936 79.2712 914.207 43.7264 914.207 0.103202",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M466.496 0.103607C466.496 34.0328 564.767 61.4992 685.989 61.4992C807.211 61.4993 905.481 34.0328 905.481 0.103646",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M457.766 0.102671C457.766 24.3378 556.036 44.049 677.258 44.0491C798.48 44.0491 896.751 24.3378 896.751 0.10271",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M449.037 0.101499C449.037 14.6426 547.308 26.5986 668.53 26.5986C789.752 26.5986 888.022 14.6426 888.022 0.101538",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M440.309 0.104872C440.309 4.95189 538.579 8.82956 659.801 8.82957C781.023 8.82958 879.294 4.95193 879.294 0.10491",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M870.569 0.102347C870.569 4.94937 772.299 8.82702 651.077 8.82701C567.353 8.827 494.62 6.88811 457.445 4.30302",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.382 0.0988797C106.382 121.274 204.653 219.507 325.875 219.507C447.097 219.507 545.367 121.274 545.367 0.0989181",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6535 0.101729C97.6535 111.583 195.924 202.061 317.146 202.061C438.368 202.061 536.962 111.583 536.962 0.101768",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6016 0.0986115C88.6016 101.886 186.872 184.609 308.094 184.609C429.316 184.609 527.587 101.886 527.587 0.0986499",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8752 0.0985279C79.8752 92.192 178.146 166.836 299.368 166.836C420.59 166.836 518.86 92.192 518.86 0.0985663",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1466 0.0992161C71.1466 82.4986 169.417 149.388 290.639 149.388C411.861 149.388 510.132 82.4986 510.132 0.0992545",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4192 0.0981252C62.4192 72.8035 160.69 131.937 281.912 131.937C403.134 131.937 501.404 72.8035 501.404 0.0981636",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6915 0.0983239C53.6915 63.1096 151.962 114.165 273.184 114.165C394.406 114.165 492.677 63.1097 492.677 0.0983623",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9639 0.0983661C44.9639 53.4156 143.235 96.7157 264.457 96.7157C385.679 96.7157 483.949 53.4157 483.949 0.0984045",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9113 0.0991349C35.9112 43.7223 134.182 79.2672 255.404 79.2672C376.626 79.2672 474.896 43.7224 474.896 0.0991733",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1837 0.0978701C27.1837 34.027 125.454 61.4935 246.676 61.4935C367.898 61.4935 466.169 34.0271 466.169 0.0979085",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4563 0.0958352C18.4563 24.331 116.727 44.0422 237.949 44.0422C359.171 44.0422 457.441 24.331 457.441 0.0958736",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72765 0.0994239C9.72765 14.6405 107.998 26.5965 229.22 26.5965C350.442 26.5965 448.713 14.6405 448.713 0.0994623",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00023 0.0988902C1.00023 4.94591 99.2708 8.82358 220.493 8.82359C341.715 8.8236 439.985 4.94595 439.985 0.0989286",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M431.258 0.0983183C431.258 4.94534 332.987 8.82299 211.765 8.82298C128.041 8.82297 55.308 6.88408 18.1333 4.299",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratgyBackground);
export default __webpack_public_path__ + "static/media/stratgy-background.2bb7b40fb11a8df6b78e9c5ecef820d8.svg";
export { ForwardRef as ReactComponent };